import { apiServer } from 'settings/web-services/api';

export function getThirdPartyStats() {
  return apiServer.get(`/user/thirdParty/dashboard/stats`);
}

export function getThirdPartyTransactionsDocumentsByIds(query) {
  return apiServer.get(`/user/thirdParty/dashboard/docs?ids=${query}`);
}
